import { useState, useEffect } from 'react'
import { getBanner } from '../api/auth'

interface BannerConfig {
  enabled: boolean
  message: string
  version: number
}

export default function BetaBanner() {
  const [config, setConfig] = useState<BannerConfig | null>(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    getBanner()
      .then((data: BannerConfig) => {
        setConfig(data)
        const dismissedVersion = localStorage.getItem('beta_banner_dismissed_version')
        if (dismissedVersion === String(data.version)) {
          setDismissed(true)
        }
      })
      .catch(() => {
        // Silently fail — don't break the page if banner API fails
      })
  }, [])

  if (!config || !config.enabled || dismissed) return null

  const handleDismiss = () => {
    localStorage.setItem('beta_banner_dismissed_version', String(config.version))
    setDismissed(true)
  }

  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(135deg, rgba(124,58,237,0.15), rgba(236,72,153,0.1))',
      borderBottom: '1px solid rgba(124,58,237,0.3)',
      padding: '8px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      position: 'relative',
      zIndex: 99999,
      backdropFilter: 'blur(8px)',
      flexShrink: 0,
      boxSizing: 'border-box',
    }}>
      <span style={{ fontSize: '16px', flexShrink: 0 }}>🚧</span>

      <p style={{
        margin: 0,
        fontFamily: 'Inter, sans-serif',
        fontSize: '13px',
        color: '#ffffff',
        textAlign: 'center',
        flex: 1,
        lineHeight: 1.5,
      }}>
        <strong style={{ color: '#A78BFA' }}>Beta</strong>
        {' — '}{config.message}
      </p>

      <button
        onClick={handleDismiss}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'rgba(255,255,255,0.5)',
          cursor: 'pointer',
          fontSize: '18px',
          padding: '0 4px',
          lineHeight: 1,
          flexShrink: 0,
        }}
        title="Dismiss"
      >
        ×
      </button>
    </div>
  )
}
